import { useMemo } from "react";

import WPTabs from "../../packages/WPTabs";

import { combineClassNames } from "../../utils/appUtils";

import "./TrainTabs.scss";

const TrainTabs = ({
  trainTabs = [],
  selectedTrain,
  onTrainChange,
  className,
  shellClassName,
}) => {
  const normalizedTrainTabs = useMemo(
    () =>
      (trainTabs || []).map((tab, index) => ({
        ...tab,
        id: tab.id || `train-tab-${tab.train || index + 1}`,
      })),
    [trainTabs],
  );

  const activeTrainTabIndex = useMemo(() => {
    const selectedIndex = normalizedTrainTabs.findIndex(
      (tab) => Number(tab.train) === Number(selectedTrain),
    );

    return selectedIndex >= 0 ? selectedIndex : 0;
  }, [normalizedTrainTabs, selectedTrain]);

  if (normalizedTrainTabs.length === 0) return null;

  return (
    <div className={combineClassNames("train-tabs-shell", shellClassName)}>
      <WPTabs
        tabs={normalizedTrainTabs}
        className={combineClassNames("train-tabs-section", className)}
        activeTabIndex={activeTrainTabIndex}
        onTabChange={(index) =>
          onTrainChange?.(normalizedTrainTabs[index]?.train)
        }
      >
        {normalizedTrainTabs.map((tab) => (
          <div key={`train-tab-content-${tab.id}`} />
        ))}
      </WPTabs>
    </div>
  );
};

export default TrainTabs;
